/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestStandardToken extends Contract<ITestStandardToken> {
  allowance: Call<(_owner: AddressLike, _spender: AddressLike) => BigNumber, ITestStandardToken>
  'allowance(address,address)': Call<(_owner: AddressLike, _spender: AddressLike) => BigNumber, ITestStandardToken>
  approve: Send<(_spender: AddressLike, _amount: BigNumberish) => boolean, ITestStandardToken>
  'approve(address,uint256)': Send<(_spender: AddressLike, _amount: BigNumberish) => boolean, ITestStandardToken>
  balanceOf: Call<(_account: AddressLike) => BigNumber, ITestStandardToken>
  'balanceOf(address)': Call<(_account: AddressLike) => BigNumber, ITestStandardToken>
  decimals: Call<() => BigNumber, ITestStandardToken>
  'decimals()': Call<() => BigNumber, ITestStandardToken>
  symbol: Call<() => string, ITestStandardToken>
  'symbol()': Call<() => string, ITestStandardToken>
  totalSupply: Call<() => BigNumber, ITestStandardToken>
  'totalSupply()': Call<() => BigNumber, ITestStandardToken>
  transfer: Send<(_recipient: AddressLike, _amount: BigNumberish) => boolean, ITestStandardToken>
  'transfer(address,uint256)': Send<(_recipient: AddressLike, _amount: BigNumberish) => boolean, ITestStandardToken>
  transferFrom: Send<(_sender: AddressLike, _recipient: AddressLike, _amount: BigNumberish) => boolean, ITestStandardToken>
  'transferFrom(address,address,uint256)': Send<(_sender: AddressLike, _recipient: AddressLike, _amount: BigNumberish) => boolean, ITestStandardToken>
}

let ITestStandardTokenBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestStandardTokenBytecode = '0x';
}

// prettier-ignore
export const ITestStandardToken = contract<ITestStandardToken>(ITestStandardTokenBytecode)`
  event Approval(address indexed owner, address indexed spender, uint256 value)
  event Transfer(address indexed from, address indexed to, uint256 value)
  function allowance(address _owner, address _spender) view returns (uint256 amount_)
  function approve(address _spender, uint256 _amount) returns (bool success_)
  function balanceOf(address _account) view returns (uint256 balance_)
  function decimals() view returns (uint8 decimals_)
  function symbol() view returns (string symbol_)
  function totalSupply() view returns (uint256 supply_)
  function transfer(address _recipient, uint256 _amount) returns (bool success_)
  function transferFrom(address _sender, address _recipient, uint256 _amount) returns (bool success_)
`;